import { withoutReview } from './reviewIdentity';

// D6: the whole-array review writes for red flags and diagnosis codes.
// Each function returns new arrays and never changes its input.

// A click on the active status returns the item to pending, which removes
// its review; any other click sets the status and stamps the item.
function toggled(item, newStatus, stamp) {
    const status = item.status === newStatus ? 'pending' : newStatus;
    return status === 'pending'
        ? { ...withoutReview(item), status }
        : { ...item, status, review: stamp };
}

export function reviewRedFlag(flags, index, newStatus, stamp) {
    return flags.map((flag, i) => (i === index ? toggled(flag, newStatus, stamp) : flag));
}

const REVIEWED_FLAG_STATUSES = new Set(['approved', 'rejected']);

// Only flags nobody reviewed yet: a bulk click keeps an earlier reviewer's
// name and never turns a dismissed flag into "Correct".
export function markAllRedFlagsReviewed(flags, stamp) {
    return flags.map((flag) => (
        REVIEWED_FLAG_STATUSES.has(flag.status)
            ? flag
            : { ...flag, status: 'approved', review: stamp }
    ));
}

// A candidate that leaves 'selected' loses any primary designation.
export function reviewCandidate(candidates, primaryIndex, index, newStatus, stamp) {
    const updated = candidates.map((cand, i) => (i === index ? toggled(cand, newStatus, stamp) : cand));
    const hadPrimary = typeof primaryIndex === 'number';
    const keepPrimary = hadPrimary && updated[primaryIndex]?.status === 'selected';
    return {
        candidates: updated,
        primaryIndex: keepPrimary ? primaryIndex : null,
        primaryCleared: hadPrimary && !keepPrimary,
    };
}

// Add-new + reject-old: indices stay stable and the AI card keeps its
// disclosures as an audit trail. The primary follows the refined code.
export function refineCandidate(candidates, primaryIndex, targetIndex, newCandidate, stamp) {
    const updated = candidates.map((cand, i) => (
        i === targetIndex
            ? { ...cand, status: 'rejected', replaced_by: newCandidate.client_id, review: stamp }
            : cand
    ));
    updated.push({ ...newCandidate, review: stamp });
    const primaryMoved = primaryIndex === targetIndex;
    return {
        candidates: updated,
        primaryIndex: primaryMoved ? updated.length - 1 : primaryIndex,
        primaryMoved,
    };
}
